import React, { useState, useCallback } from 'react';
import Modal from 'simple-react-modal';

import { SEND_AUDITION_FORM } from '../../constants/apiUrls/apiUrls';
import callApi from '../../utils/callApi';


function AmateurAuditionsForm() {

  const [formData, setFormData] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState('');

  const handleInput = useCallback((e) => {
    const { value } = e.target;
    const field = e.target.id;
    setFormData({
      ...formData,
      [field]: value,
    });
  }, [formData]);

  const closeSuccessMessage = useCallback(() => {
    setShowMessage(false);
  }, [showMessage]);

  const submitForm = useCallback(() => {
    callApi(SEND_AUDITION_FORM, 'post', {}, formData, {}, false, false, false).
      then((res) => {
        if (res.status === 204) {
          setShowMessage(true);
          setMessage('Thank You for your submission, our producer will contact you shortly.');
          setFormData({ name: '', email: '', location: '', instagram: '', phone: '', twitter: '', tiktok: '', youtube: '', reason: '' });
        }
      }).
      catch((err) => {

        setShowMessage(true);
        setMessage('Name, E-mail & Location are mandatory fields.');

      });
  }, [formData, showMessage, message]);

  return (
    <div className="amateur-audition-form">
      <h6>You must be 18 years or older to audition for Naked News</h6>

      <form action="" className="audition-form-grid">
        <div className="amateur-audition-form inputs">
          <label htmlFor="name">NAME</label>
          <input id="name" placeholder={'Your Name'} required="required" type="text" value={formData.name} onChange={handleInput} />
        </div>
        <div className="amateur-audition-form inputs">
          <label htmlFor="email">E-MAIL</label>
          <input id="email" placeholder={'email@domainname.com'} required="required" type="text" value={formData.email} onChange={handleInput} />
        </div>
        <div className="amateur-audition-form inputs">
          <label htmlFor="location">LOCATION</label>
          <input id="location" placeholder={'City, Country'} required="required" type="text" value={formData.location} onChange={handleInput} />
        </div>
        <div className="amateur-audition-form inputs">
          <label htmlFor="phone">PHONE NUMBER</label>
          <input id="phone" placeholder={'+1 999-999-9999'} type="text" value={formData.phone} onChange={handleInput} />
        </div>
        <div className="amateur-audition-form inputs">
          <label htmlFor="instagram">INSTAGRAM</label>
          <input id="instagram" placeholder={'example.eg'} type="text" value={formData.instagram} onChange={handleInput} />
        </div>
        <div className="amateur-audition-form inputs">
          <label htmlFor="twitter">TWITTER</label>
          <input id="twitter" placeholder={'@username'} type="text" value={formData.twitter} onChange={handleInput} />
        </div>
        <div className="amateur-audition-form inputs">
          <label htmlFor="tiktok">TIKTOK</label>
          <input id="tiktok" placeholder={'@username'} type="text" value={formData.tiktok} onChange={handleInput} />
        </div>
        <div className="amateur-audition-form inputs">
          <label htmlFor="youtube">YOUTUBE</label>
          <input id="youtube" placeholder={'ChannelName'} type="text" value={formData.youtube} onChange={handleInput} />
        </div>
        <textarea className="text-box" cols={40} id="reason" placeholder="Tell us why you want to be a Naked News Anchor" rows={5} value={formData.reason} onChange={handleInput} />
      </form>

      <button className="audition-form-submit" onClick={submitForm}>Submit</button>

      <Modal
        closeOnOuterClick={true}
        containerStyle={{
          width: '100%',
          padding: '0',
          marginTop: '100px',
          background: 'transparent',
        }}
        show={showMessage}
      >
        <div className="audition-form-success-message">
          <button onClick={closeSuccessMessage}>X</button>
          <h4>{message}</h4>
        </div>
      </Modal>
    </div>
  );

}

export default AmateurAuditionsForm;
